import styled, { css } from 'styled-components';

export const CaptionCss = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
`;

export default styled.span`
  ${CaptionCss}
`;
